import { Button, Icon, IconButton, Tooltip, Typography } from '@smartgift/frontend-toolkit';
import cn from 'classnames';
import React, { useState } from 'react';

import * as S from './style';

export function DetailItem({
  title,
  titleIcon,
  titleIconOnClick,
  editInput,
  radioButtonInput,
  children,
  editable,
  withBorder,
  titleStyle,
  contentStyle,
  bodyStyle,
  onClickEditButton,
  extraField,
  saveDetail = () => {},
  editButton,
  required = false,
  className,
  value = '',
  isCTADisabled = false,
  closeWithoutSave,
  editButtonText,
  actionAreaStyle,
  tooltipContent,
  hasActionButtons = true
}) {
  const [edit, setEdit] = useState(false);

  const toggleButton = () => {
    if (closeWithoutSave) closeWithoutSave();
    setEdit(!edit);
  };

  const saveAndClose = () => {
    if (!required || (required && value)) {
      saveDetail();
      setEdit(!edit);
    }
  };

  const _actionView = () => {
    if (edit && !editButton) {
      return (
        <div className="action-buttons" style={actionAreaStyle}>
          <S.ItemButton onClick={toggleButton}>
            <Icon name="close" />
          </S.ItemButton>
          <S.ItemButton onClick={saveAndClose} inactive={isCTADisabled} disabled={isCTADisabled}>
            <Icon name="success" />
          </S.ItemButton>
        </div>
      );
    }

    return (
      <Button
        variant="link"
        onClick={() => {
          if (onClickEditButton) onClickEditButton();
          else toggleButton();
        }}
      >
        {editButton ? (
          editButton()
        ) : (
          <>
            <Icon name="edit" />
            {!!editButtonText && editButtonText}
          </>
        )}
      </Button>
    );
  };

  return (
    <S.DetailItem
      withBorder={withBorder}
      editable={editable}
      editing={edit && !editButton}
      hasActionButtons={hasActionButtons}
    >
      <div className={cn('item-body', className)} style={bodyStyle}>
        <S.TitleWrapper style={titleStyle}>
          {titleIcon && (
            <Tooltip content={tooltipContent} tooltipConfig={{ placement: 'top' }}>
              <IconButton variant="link" onClick={titleIconOnClick}>
                <Icon name="tooltip" color="var(--color-fg-weak)" size="sm" />
              </IconButton>
            </Tooltip>
          )}
          <Typography variant="body2SemiBold" color="fg" emphasis="weaker">
            {title}
          </Typography>
        </S.TitleWrapper>
        <div className="item-content" style={contentStyle}>
          {edit && !editButton ? (
            <>
              {editInput && editInput()}
              {radioButtonInput && radioButtonInput()}
            </>
          ) : typeof children === 'string' ? (
            <Typography variant="body2" color="fg" emphasis="weak">
              {children}
            </Typography>
          ) : (
            children
          )}
        </div>
        {editable && _actionView()}
      </div>
      {extraField && <S.DetailItemFooter>{extraField()}</S.DetailItemFooter>}
    </S.DetailItem>
  );
}

DetailItem.S = {
  Wrapper: S.DetailItem
};
